import Raven from 'raven-js';
import { isNetworkError } from '../types/NetworkError';
// Network error
const STATUS = 'status';
const STATUS_TEXT = 'statusText';
const CORRELATION_ID = 'correlationId';

// User defined
const CALL_PROVIDER = 'callProvider';
const SDK_VERSION = 'sdkVersion';
const EXTERNAL_CALL_ID = 'externalCallId';
const networkErrorKeys = {
  STATUS,
  STATUS_TEXT,
  CORRELATION_ID
};
const extraDataKeys = {
  CALL_PROVIDER,
  SDK_VERSION,
  EXTERNAL_CALL_ID
};
const DEFAULTS = {
  extra: {},
  tags: {},
  fingerprint: [],
  level: 'info'
};
export const createErrorExtra = extraData => {
  return Object.assign({}, extraData[CALL_PROVIDER] !== undefined && {
    callProvider: extraData[CALL_PROVIDER]
  }, extraData[SDK_VERSION] !== undefined && {
    sdkVersion: extraData[SDK_VERSION]
  }, extraData[EXTERNAL_CALL_ID] !== undefined && {
    externalCallId: extraData[EXTERNAL_CALL_ID]
  });
};
export const logNetworkError = ({
  message,
  networkError,
  extraData,
  tags
}) => {
  const error = new Error(message);
  const options = Object.assign({}, DEFAULTS);
  if (tags) {
    options.tags = tags;
  }
  if (isNetworkError(networkError)) {
    const {
      status,
      statusText,
      responseJSON
    } = networkError;
    const correlationId = (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.correlationId) || '';
    const {
      callProvider
    } = extraData || {};
    options.extra = Object.assign({}, extraData ? createErrorExtra(extraData) : {}, {
      status,
      statusText,
      correlationId
    });
    if (correlationId) {
      options.tags = Object.assign({}, options.tags, {
        correlationId
      });
    }
    if (callProvider) {
      options.tags = Object.assign({}, options.tags, {
        callProvider
      });
    }
    Raven.captureException(error, options);
  }
  return networkError;
};